import { useNavigate, useParams } from "react-router-dom";
import { useBackdropState } from "../../BackDrop/BackDropProvider";

function useOnClickFunctions() {
  const { removeOpenedBy } = useBackdropState();
  const navigate = useNavigate();
  const { restaurantId, tableId } = useParams();

  const handleClose = () => {
    removeOpenedBy("transparent-drawer");
    navigate(`/restaurants/${restaurantId}/tables/${tableId}/bills`);
  };

  const handleNavigate = (path: string) => {
    requestAnimationFrame(() => {
      navigate(path);
    });
  };

  return { handleClose, handleNavigate };
}

export default useOnClickFunctions;
